"use client"

import { Link } from "react-router-dom"

import { AdminThemeToggle } from "@/components/admin-theme-toggle"
import { ConnectButton } from "@/components/connect-button"
import SiteLogo from "@/components/site-logo"
import { cn } from "@/domains/library"
import { NavigationDropdownBar } from "@/domains/navigation/components/nav-dropdown"
import useResponsive from "@/hooks/use-responsive"

import { DesktopNavLayout } from "./desktop-nav-layout"

export const Navbar = ({ className, navClassName }: { className?: string; navClassName?: string }) => {
  const { preferMobileNav } = useResponsive()

  const logoSize = {
    width: 158,
    height: 44,
  }

  if (!preferMobileNav) {
    const scale = 0.6
    return (
      <div className={cn("page-container one mx-auto w-full min-w-[320px] max-w-[calc(2200px-128px)]", className)}>
        <DesktopNavLayout
          logo={
            <SiteLogo
              width={logoSize.width * scale}
              height={logoSize.height * scale}
              className="z-100 justify-center gap-1"
            />
          }
          navigationDropdownBar={<NavigationDropdownBar className={navClassName} />}
          buttons={
            <div className="flex items-center gap-2">
              <AdminThemeToggle />
              <ConnectButton />
            </div>
          }
        />
      </div>
    )
  }

  const scale = 0.5
  return (
    <div className="flex flex-col gap-3 border-b border-p400-light bg-p500/90 px-4 py-4 backdrop-blur">
      <div className="flex items-center justify-between gap-2">
        <SiteLogo width={logoSize.width * scale} height={logoSize.height * scale} className="justify-center gap-1" />
        <ConnectButton />
      </div>
      <nav className="flex items-center gap-2 overflow-x-auto text-sm text-t200" aria-label="Primary">
        {MOBILE_NAV_LINKS.map((link) => (
          <Link
            key={link.href}
            to={link.href}
            className="rounded-lg border border-p400-light bg-p400 px-3 py-2 font-medium transition-colors hover:bg-p400-light hover:text-t100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            {link.label}
          </Link>
        ))}
      </nav>
    </div>
  )
}

const MOBILE_NAV_LINKS = [
  { label: "Swap", href: "/swap" },
  { label: "Liquidity", href: "/liquidity" },
  { label: "Vote", href: "/vote" },
  { label: "Dashboard", href: "/dashboard" },
] as const
